import { Component, Prop, Vue } from "vue-property-decorator";
import { Badge } from "ant-design-vue";
import { LessonPlanLocale } from "@/locales/localeid";
import { ComponentTaughtType, LessonPlanItemType } from "@/models/master-plan";

@Component({
	components: {
		"a-badge": Badge
	}
})
export default class LessonPlanCell extends Vue {
	@Prop({ default: ComponentTaughtType.None }) taughtType!: ComponentTaughtType;
	@Prop() lessonSequence?: number;

	get componentTaughtType(): any {
		return ComponentTaughtType;
	}

	get lessonPlanLocale(): any {
		return LessonPlanLocale;
	}
}
